import { MonthChangeEventHandler } from '@daypicker/react'
import { useState } from 'react'

export const useMonthControl = (month: Date | undefined, onMonthChange: MonthChangeEventHandler | undefined) => {
    const [internalMonth, setInternalMonth] = useState<Date | undefined>(month)
    const monthSelected = month ?? internalMonth

    const handleOnMonthChange = (newMonth: Date): void => {
        setInternalMonth(newMonth)
        onMonthChange?.(newMonth)
    }

    return { monthSelected, handleOnMonthChange }
}
